export default __webpack_public_path__ + "static/media/brand.47d7d927.png";